import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { withDefaults, ref, computed } from 'vue';
import { message } from "ant-design-vue";
import { PlusOutlined } from '@ant-design/icons-vue';
import { BaseUpload } from './data';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    accept: { default: null },
    uploadFn: { type: Function, default: null },
    uploadFimeName: { default: null },
    multiple: { type: Boolean, default: true },
    count: { default: null },
    selectUpload: { type: Boolean, default: true },
    className: {},
    visible: { type: Boolean },
    size: {},
    placeholder: {},
    disabled: { type: Boolean, default: false },
    readOnly: { type: Boolean },
    defaultValue: {},
    value: { default: null },
    onChange: {}
  },
  emits: ["uploadFile"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const acceptType = computed(() => {
    switch (props.accept) {
        case 'image':
            return '.png, .jpg, .jpeg';
        case 'file':
            return '.doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt, .zip, .rar, .7z, .jpg, .png, .jpeg';
        case 'video':
            return '.mp4, .avi, .mov, .rmvb, .wmv';
        default:
            return '';
    }
});

const fileList = ref([]);

const uploadLimit = computed(() => {
    return !props.count || fileList.value.length < props.count;
})


const setFileList = (list) => {
    const time = new Date();
    list.forEach((url) => {
        const name = url.slice(url.lastIndexOf("/") + 1, url.length);
        fileList.value.push({
            uid: time.getTime() + Math.random(),
            status: "done",
            name: name,
            url,
        });
    });
};

if (props.value) {
    const data = props.value.split(',');
    setFileList(data);
}

const handleUploadChange = (file) => {

};

const getFile = (upload: boolean) => {
    return fileList.value.filter((f) => Boolean(f.url) === upload);
}

const emit = __emit

const upload = (formData) => {
    return new Promise((resolve, reject) => {
        props.uploadFn(formData)
            .then((res) => {
                if (res.code === 200 || res.errno === 0) {
                    const cacheFile = [];
                    fileList.value.forEach((item) => {
                        if (item.url) {
                            cacheFile.push(item.url);
                        }
                    });
                    if (Object.prototype.toString.call(res.data) === '[object Array]') {
                        cacheFile.push(...res.data);
                    }
                    if (Object.prototype.toString.call(res.data) === '[object String]') {
                        cacheFile.push(res.data);
                    }
                    if (Object.prototype.toString.call(res.data) === '[object Object]') {
                        cacheFile.push(res.data.url);
                    }
                    emit('uploadFile', cacheFile);
                    resolve(cacheFile);
                } else {
                    reject();
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

const uploadFile = () => {
    return new Promise(async (resolve, reject) => {
        const formData = new FormData();

        const uploadFile = getFile(false);
        const unUploadFile = getFile(true);

        if (uploadFile.length === 0) {
            let fileUrl = [];
            unUploadFile.forEach((item) => fileUrl.push(item.url));
            emit('uploadFile', fileUrl);
            resolve(fileUrl);
            return;
        }

        uploadFile.forEach((file) => {
            formData.append(props.uploadFimeName, file.originFileObj)
        });

        const data = await upload(formData);

        resolve(data);
    });
}

const setfileStatus = (uid, status) => {
    fileList.value.find((f) => f.uid === uid).status = status;
}

const setfileUrl = (uid, url) => {
    fileList.value.find((f) => f.uid === uid).url = url;
}

const customRequest = (e) => {
    const { file } = e;
    if (props.selectUpload) {
        const formData = new FormData();
        formData.append(props.uploadFimeName, file);
        upload(formData).then((res: any) => {
            const lastIndex = res.length - 1;
            message.success('上传成功');
            setfileUrl(file.uid, res[lastIndex]);
            setfileStatus(file.uid, 'done')
            console.log(fileList.value, 'file list');
        }).catch((err) => {
            setfileStatus(file.uid, 'failed')
        });
    }
};

__expose({
    uploadFile,
    fileList,
    getFile,
})



return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createBlock(_component_a_upload, {
    accept: acceptType.value,
    "file-list": fileList.value,
    "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
    multiple: props.multiple,
    "custom-request": customRequest,
    onChange: handleUploadChange,
    disabled: props.disabled
  }, {
    default: _withCtx(() => [
      (uploadLimit.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_button, null, {
              default: _withCtx(() => [
                _createVNode(_unref(PlusOutlined)),
                _createTextVNode("上传文件")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["accept", "file-list", "multiple", "disabled"]))
}
}

})